import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Progress, Spin, Icon } from 'antd';
import api from '../../services/api';

import BarGraphQtd from './BarGraphQtd';
import BarGraphValues from './BarGraphValues';

import {
  Container, Grid, Card, Group, Count,
} from './styles';

export default function Dashboard({
  dates, data, loading, product,
}) {
  const startAt = useMemo(() => dates[0].replace(/-/g, '/'), [dates]);
  const endAt = useMemo(() => dates[1].replace(/-/g, '/'), [dates]);

  const [responseGraph, setResponseGraph] = useState([]);
  const [responseLoading, setResponseLoading] = useState(false);
  const [datesQueryResponse, setDatesQueryResponse] = useState([]);

  // const [active, setAvtive] = useState('');


  // const maxValue = useMemo(() => {
  //   const billets = data.billets && data.billets[0].count ? data.billets[0].count : 0;
  //   const ted = data.ted && data.ted[0].count ? data.ted[0].count : 0;
  //   const transfers = data.transfers && data.transfers[0].count ? data.transfers[0].count : 0;
  //   const payments = data.payments && data.payments[0].count ? data.payments[0].count : 0;
  //   const saques = data.saques && data.saques[0].count ? data.saques[0].count : 0;

  //   return Math.max.apply(null, [billets, ted, transfers, payments, saques]);
  // }, [data]);


  useEffect(() => {
    setResponseGraph([]);
  }, [dates, product]);


  const handleClickService = async (key) => {
    setResponseLoading(true);
    // setAvtive(key);
    const startAtt = moment(startAt, 'DD/MM/YYYY').format('YYYY-MM-DD');
    const endAtt = moment(endAt, 'DD/MM/YYYY').format('YYYY-MM-DD');

    const datesQuery = [];

    for (let i = 0; i <= 12; i += 1) {
      const start = moment(startAtt).subtract(i, 'month').startOf('month').format('YYYY-MM-DD');
      const end = moment(endAtt).subtract(i, 'month').endOf('month').format('YYYY-MM-DD');
      const name = moment(startAtt).subtract(i, 'month').format('MMMM');
      datesQuery.unshift({ name, start, end });
    }

    setDatesQueryResponse(datesQuery);

    try {
      const response = await Promise.all(
        datesQuery.map((query) => api.get(`dashboard/${product}?start=${query.start}&end=${query.end}`)),
      );

      const formatResponse = response.map((r) => r.data.data[key]);

      setResponseGraph(formatResponse);
      setResponseLoading(false);
    } catch (err) {
      console.log('e', err);
      setResponseLoading(false);
    }
  };

  function formatMoney(value = 0) {
    const decimalCount = 2;
    const decimal = ',';
    const thousands = '.';

    let amount = value;
    const negativeSign = amount < 0 ? '-' : '';
    const i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)), 0).toString();
    const j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign
      + (j ? i.substr(0, j) + thousands : '')
      + i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${thousands}`)
      + (decimalCount
        ? decimal
          + Math.abs(amount - i)
            .toFixed(decimalCount)
            .slice(2)
        : '')
    );
  }

  return (
    <Container>
      <Grid>
        <Card header>
          <h1>
            Contas
          </h1>
          {loading ? (
            <Spin
              style={{ marginTop: 30 }}
              indicator={<Icon type="loading" style={{ fontSize: 24, color: '#3ec4b8' }} spin />}
            />
          ) : (
            <section style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div>
                <h4>Abertas</h4>
                <span style={{ fontSize: '22px' }}>{data.accounts[0].count}</span>

                <h4>Total</h4>
                <span style={{ fontSize: '22px' }}>{data.totalAccount[0].count}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ marginRight: '15px' }}>
                  <h5 style={{ display: 'flex', fontSize: '14px', alignItems: 'center' }}>
                    <div
                      style={{
                        background: '#1890ff',
                        width: '15px',
                        height: '15px',
                        marginRight: '5px',
                        borderRadius: '50%',
                      }}
                    />
                    Ativas
                    <span style={{ fontWeight: 'bold', marginLeft: '5px' }}>
                      {data.actives}
                    </span>
                  </h5>
                  <h5 style={{ display: 'flex', fontSize: '14px', alignItems: 'center' }}>
                    <div
                      style={{
                        background: 'transparent',
                        width: '15px',
                        height: '15px',
                        marginRight: '5px',
                        borderRadius: '50%',
                      }}
                    />
                  </h5>
                </div>
                <div>
                  <Progress
                    type="circle"
                    showInfo
                    percent={Math.floor((data.actives * 100) / data.totalAccount[0].count)}
                  />
                </div>
              </div>
            </section>
          )}
        </Card>
        <Card header>
          <h1>
            Cartões
          </h1>
          {loading ? (
            <Spin
              style={{ marginTop: 30 }}
              indicator={<Icon type="loading" style={{ fontSize: 24, color: '#3ec4b8' }} spin />}
            />
          ) : (
            <section style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', flexDirection: 'column', marginRight: '30px' }}>
                  <span style={{ display: 'flex', alignItems: 'center' }}>
                    <div
                      style={{
                        background: '#f5f5f5',
                        width: '15px',
                        height: '15px',
                        marginRight: '5px',
                        borderRadius: '50%',
                      }}
                    />
                    Valor total de uso
                  </span>
                  <em style={{ fontStyle: 'normal', fontSize: '20px', color: '#171717' }}>
                    R$ {formatMoney(data.cardsUse[0].total)}
                  </em>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                  <span style={{ display: 'flex', alignItems: 'center' }}>
                    <div
                      style={{
                        background: '#1890ff',
                        width: '15px',
                        height: '15px',
                        marginRight: '5px',
                        borderRadius: '50%',
                      }}
                    />
                    Quantidade de vezes usada
                  </span>
                  <em style={{ fontStyle: 'normal', fontSize: '20px', color: '#171717' }}>
                    {data.cardsUse[0].count}
                  </em>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                  <span style={{ display: 'flex', alignItems: 'center' }}>
                    <div
                      style={{
                        background: 'transparent',
                        width: '15px',
                        height: '15px',
                        marginRight: '5px',
                        borderRadius: '50%',
                      }}
                    />
                    Ticket médio
                  </span>
                  <em style={{ fontStyle: 'normal', fontSize: '20px', color: '#171717' }}>
                    R$ {formatMoney(Math.round(data.cardsUse[0].total / data.cardsUse[0].count))}
                  </em>
                </div>
              </div>
              <Progress
                type="line"
                percent={Math.floor((data.cardsUse[0].count * 100) / data.cardsUse[0].total)}
                showInfo={false}
              />
            </section>
          )}
        </Card>
      </Grid>
      <Grid>
        <Card direction="row">
          <h1 style={{ width: '100%' }}>
            Métricas
          </h1>
          {loading ? (
            <Spin
              style={{ marginTop: 30 }}
              indicator={<Icon type="loading" style={{ fontSize: 24, color: '#3ec4b8' }} spin />}
            />
          ) : (
            <>
              <Group>
                <em onClick={() => handleClickService('billets')}>
                  <div>
                    <span>Boletos emitidos</span>
                    <Count>{data.billets && data.billets[0].count}</Count>
                  </div>
                  <div>
                    <Count>R$ {data.billets && formatMoney(data.billets[0].sum)}</Count>
                  </div>
                </em>
              </Group>
              <Group>
                <em onClick={() => handleClickService('ted')}>
                  <div>
                    <span>TED</span>
                    <Count>{data.ted && data.ted[0].count}</Count>
                  </div>
                  <div>
                    <Count>R$ {data.ted && formatMoney(data.ted[0].sum)}</Count>
                  </div>
                </em>
              </Group>
              <Group>
                <em onClick={() => handleClickService('transfers')}>
                  <div>
                    <span>Transferência entre contas</span>
                    <Count>{data.transfers && data.transfers[0].count}</Count>
                  </div>
                  <div>
                    <Count>R$ {data.transfers && formatMoney(data.transfers[0].sum)}</Count>
                  </div>
                </em>
              </Group>
              <Group>
                <em onClick={() => handleClickService('payments')}>
                  <div>
                    <span>Pagamento de contas</span>
                    <Count>{data.payments && data.payments[0].count}</Count>
                  </div>
                  <div>
                    <Count>R$ {data.payments && formatMoney(data.payments[0].sum)}</Count>
                  </div>
                </em>
              </Group>
              <Group>
                <em onClick={() => handleClickService('saques')}>
                  <div>
                    <span>Saques</span>
                    <Count>{data.saques && data.saques[0].count}</Count>
                  </div>
                  <div>
                    <Count>R$ {data.saques && formatMoney(data.saques[0].total)}</Count>
                  </div>
                </em>
              </Group>
              <Group>
                <em onClick={() => handleClickService('cards')}>
                  <div>
                    <span>Cartões ativados</span>
                    <Count>{data.cards && data.cards[0].count}</Count>
                  </div>
                  <div>
                    <Count>{data.saques && formatMoney(data.saques[0].total)}</Count>
                  </div>
                </em>
              </Group>
            </>
          )}
        </Card>
      </Grid>
      <Grid>
        <Card>
          <h1>Últimos 12 meses (Quantidades)</h1>
          {/* {String(active).toUpperCase()} */}
          {responseLoading ? (
            <Spin
              style={{ marginTop: 30 }}
              indicator={<Icon type="loading" style={{ fontSize: 24, color: '#3ec4b8' }} spin />}
            />
          ) : (
            <div>
              {responseGraph.length ? <BarGraphQtd data={responseGraph} labels={datesQueryResponse} /> : (
                <div>
                  Selecione uma <strong>métrica</strong> acima para ver a evolução ao longo do tempo.
                </div>
              )}

            </div>
          )}
        </Card>
        <Card>
          <h1>Últimos 6 meses (Valores)</h1>
          {/* {String(active).toUpperCase()} */}
          {responseLoading ? (
            <Spin
              style={{ marginTop: 30 }}
              indicator={<Icon type="loading" style={{ fontSize: 24, color: '#3ec4b8' }} spin />}
            />
          ) : (
            <div>
              {responseGraph.length ? <BarGraphValues data={responseGraph} labels={datesQueryResponse} /> : (
                <div>
                  Selecione uma <strong>métrica</strong> acima para ver a evolução ao longo do tempo.
                </div>
              )}

            </div>
          )}
        </Card>
      </Grid>
    </Container>
  );
}

Dashboard.propTypes = {
  dates: PropTypes.arrayOf(PropTypes.string).isRequired,
  product: PropTypes.string.isRequired,
  data: PropTypes.shape({
    actives: PropTypes.number,
    accounts: PropTypes.arrayOf(
      PropTypes.shape({
        count: PropTypes.string,
      }),
    ),
    totalAccount: PropTypes.arrayOf(
      PropTypes.shape({
        count: PropTypes.string,
      }),
    ),
    saques: PropTypes.arrayOf(
      PropTypes.shape({
        count: PropTypes.string,
        total: PropTypes.number,
      }),
    ),
    billets: PropTypes.arrayOf(
      PropTypes.shape({
        count: PropTypes.string,
        sum: PropTypes.string,
      }),
    ),
    cards: PropTypes.arrayOf(
      PropTypes.shape({
        count: PropTypes.string,
      }),
    ),
    payments: PropTypes.arrayOf(
      PropTypes.shape({
        count: PropTypes.string,
        sum: PropTypes.string,
      }),
    ),
    transfers: PropTypes.arrayOf(
      PropTypes.shape({
        count: PropTypes.string,
        sum: PropTypes.string,
      }),
    ),
    ted: PropTypes.arrayOf(
      PropTypes.shape({
        count: PropTypes.string,
        sum: PropTypes.string,
      }),
    ),
    cardsUse: PropTypes.arrayOf(
      PropTypes.shape({
        count: PropTypes.string,
        total: PropTypes.number,
      }),
    ),
  }).isRequired,
  loading: PropTypes.bool.isRequired,
};
